var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 2.5,
    fill: "#61ACFF",
    stroke: "#24497E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.267 18.25L8.71 14.753 7.5 15.935l4.767 4.69L22.5 10.558l-1.202-1.183-9.031 8.876z",
    fill: "#fff",
    stroke: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgcng9IjIuNSIgZmlsbD0iIzYxQUNGRiIgc3Ryb2tlPSIjMjQ0OTdFIi8+CjxwYXRoIGQ9Ik0xMi4yNjY5IDE4LjI1MDhMOC43MTA5MiAxNC43NTI1TDcuNSAxNS45MzU0TDEyLjI2NjkgMjAuNjI1TDIyLjUgMTAuNTU3OUwyMS4yOTc2IDkuMzc1TDEyLjI2NjkgMTguMjUwOFoiIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgOnboardingCheckboxChecked as ReactComponent };